
// src/Components/Invoice/ProformaInvoiceList.js

import React, { useState, useEffect } from "react";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { connect } from "react-redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { bindActionCreators } from "redux";
import axios from "axios";
import config from "../../Helpers/config.json";
import { formatAmount } from "../../Utils/formatAmount";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPrint, faTrash, faEye, faFileAlt } from "@fortawesome/free-solid-svg-icons";

function ProformaInvoiceList({ actions, snackbars }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [search, setSearch] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState("");

  const { open, variant, message } = snackbars;

  const fetchProformaInvoices = async () => {
    setLoading(true);
    try {
      const params = {
        search,
        date_from: dateFrom,
        date_to: dateTo,
        status,
        page,
        per_page: 20
      };

      const res = await axios.get(`${config.epharmUrl}/Cinvoice/proforma_invoices`, { params });

      if (res.data.status === 200) {
        setInvoices(res.data.data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalPages(res.data.total_pages || 1);
      }
    } catch (err) {
      actions.snackbarActions.errorSnackbar("Failed to load proforma invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProformaInvoices();
  }, [page, search, dateFrom, dateTo, status]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Proforma Invoice?")) return;
    
    try {
      const res = await axios.post(`${config.epharmUrl}/Cinvoice/proforma_invoice/delete/${id}`);
      if (res.data.status === 200) {
        actions.snackbarActions.successSnackbar("Proforma Invoice deleted successfully");
        fetchProformaInvoices();
      }
    } catch (err) {
      actions.snackbarActions.errorSnackbar("Failed to delete");
    }
  };

  const handleBigPrint = (id) => {
    history.push(`/proforma-invoice/big/${id}`, "_blank");
  };

  const handleView = (id) => history.push(`/proforma-invoice/view/${id}`);
  const handleEdit = (id) => history.push(`/proforma-invoice/edit/${id}`);

  return (
    <>
      <ReusableDashboardHeader
        component="Proforma Invoices"
        heading="Proforma Invoices"
        link={history.location.pathname}
      />

      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4>Proforma Invoices Management</h4>
          <button 
            className="btn pharmacy-btn" 
            onClick={() => history.push("/proforma-invoice/new")}
          >
            + New Proforma Invoice
          </button>
        </div>

        {/* Filters */}
        <div className="card p-3 mb-4">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <input 
                type="text" 
                className="form-control" 
                placeholder="Search Invoice or Customer..." 
                value={search} 
                onChange={(e) => setSearch(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">From Date</label>
              <input 
                type="date" 
                className="form-control" 
                value={dateFrom} 
                onChange={(e) => setDateFrom(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">To Date</label>
              <input 
                type="date" 
                className="form-control" 
                value={dateTo} 
                onChange={(e) => setDateTo(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">Status</label>
              <select 
                className="form-control" 
                value={status} 
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="9">Deleted</option>
              </select>
            </div>
            <div className="col-md-3">
              <button 
                className="btn btn-primary w-100" 
                onClick={() => setPage(1)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div className="card-body">
            <table className="table table-hover table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Proforma No</th>
                  <th>Customer</th>
                  <th>Date</th>
                  <th className="text-end">Total Amount</th>
                  <th>Status</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="6" className="text-center py-4">Loading...</td></tr>
                ) : invoices.length === 0 ? (
                  <tr><td colSpan="6" className="text-center py-4">No proforma invoices found</td></tr>
                ) : (
                  invoices.map(inv => (
                    <tr key={inv.id}>
                      <td><strong>{inv.proforma_invoice_number}</strong></td>
                      <td>{inv.customer_name}</td>
                      <td>{inv.date}</td>
                      <td className="text-end">{formatAmount(inv.total_amount)}</td>
                      <td>
                        <span className={`badge ${inv.status === 1 ? "bg-success" : "bg-danger"}`}>
                          {inv.status === 1 ? "Active" : "Deleted"}
                        </span>
                      </td>
                      <td className="text-center">
                        <button 
                          className="btn btn-sm btn-info me-1" 
                          onClick={() => handleView(inv.id)} 
                          title="View"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                        
                        <button 
                          className="btn btn-sm btn-warning me-1" 
                          onClick={() => handleEdit(inv.id)} 
                          title="Edit"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>

                        <button 
                          className="btn btn-sm btn-primary me-1" 
                          onClick={() => handleBigPrint(inv.id)} 
                          title="Big A4 Print"
                        >
                          <FontAwesomeIcon icon={faFileAlt} />
                        </button>

                        {inv.status === 1 && (
                          <button 
                            className="btn btn-sm btn-danger" 
                            onClick={() => handleDelete(inv.id)} 
                            title="Delete"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div>
              Showing {(page - 1) * 20 + 1} to {Math.min(page * 20, totalRecords)} of {totalRecords} records
            </div>
            <nav>
              <ul className="pagination">
                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setPage(p => Math.max(1, p - 1))}>
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                  <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setPage(p)}>
                      {p}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setPage(p => Math.min(totalPages, p + 1))}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({ snackbars: state.snackbars });
const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProformaInvoiceList);